// Small vibrations on phones / tablets.
//   • Android (Chrome, Samsung…): the Vibration API, with short patterns.
//   • iPhone / iPad (iOS 18+): Safari has no Vibration API, but flipping a native iOS switch
//     (<input type="checkbox" switch>) gives the system "tick" — we flip a hidden one.
//     One tick per moment (iOS can't do patterns), and only right after a tap.
//   • Desktop: nothing.
// On by default; the "Vibrations" switch in the settings menu turns them off (saved in localStorage).

const KEY = 'hapticsEnabled';

const hasWindow = typeof window !== 'undefined' && typeof navigator !== 'undefined';
const isTouch = () => hasWindow && window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
const isIOS = () => hasWindow && (/iPad|iPhone|iPod/.test(navigator.userAgent)
  || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1));   // iPadOS reports "Mac"
const hasVibrationApi = () => hasWindow && typeof navigator.vibrate === 'function';

export const canVibrate = () => isTouch() && (hasVibrationApi() || isIOS());

export const hapticsEnabled = () => {
  try { return localStorage.getItem(KEY) !== 'off'; } catch (e) { return true; }
};
export const setHapticsEnabled = (on) => {
  try { localStorage.setItem(KEY, on ? 'on' : 'off'); } catch (e) { /* private mode */ }
};

// Android patterns in ms: vibrate, pause, vibrate, …  (under ~15 ms many phones feel nothing)
const PATTERNS = {
  tap: 20,                // a pick goes into the bet slip
  placed: [30, 50, 30],   // bets placed
  goal: [70, 50, 70],     // goal in a live game
  yourTurn: [35, 60, 35], // draft: it's your pick
  pick: 20,               // draft: a pick was confirmed
  timeUp: 140,            // draft: timer ran out
};

// iOS: a hidden native switch; clicking its label flips it and iOS plays the haptic tick
let iosLabel = null;
function iosTick() {
  if (!iosLabel) {
    const input = document.createElement('input');
    input.type = 'checkbox';
    input.setAttribute('switch', '');
    input.id = 'bdb-haptic-switch';
    input.setAttribute('aria-hidden', 'true');
    input.tabIndex = -1;
    input.style.cssText = 'position:fixed;left:-9999px;top:0;width:1px;height:1px;opacity:0;pointer-events:none;';
    const label = document.createElement('label');
    label.htmlFor = input.id;
    label.setAttribute('aria-hidden', 'true');
    label.style.cssText = 'position:fixed;left:-9999px;top:0;width:1px;height:1px;opacity:0;pointer-events:none;';
    document.body.appendChild(input);
    document.body.appendChild(label);
    iosLabel = label;
  }
  iosLabel.click();
}

export function vibrate(name) {
  if (!hapticsEnabled() || !canVibrate() || PATTERNS[name] == null) return;
  try {
    if (hasVibrationApi()) navigator.vibrate(PATTERNS[name]);
    else if (isIOS()) iosTick();
  } catch (e) { /* never break the app for a buzz */ }
}
